// extracted by mini-css-extract-plugin
export var columnList = "_be-0";